import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import MapRevitValue from "./MapRevitValue.graphql";

export default function useMapRevitValue(
    parameterID,
    bimClassID,
    value: unknown,
    revitValue: unknown,
) {
    return useMutation(
        gql(MapRevitValue),
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                "RevitValues",
            ],
            variables: {
                parameterID,
                bimClassID,
                value,
                revitValue,
            },
        },
    );
}
